module.exports = __webpack_public_path__ + "img/News_Center_sm.6d51315c.png";